module.exports = {
  IPC: 'I',
  POSTAL_OPERATOR: 'O',
  CARRIER: 'C',
  HANDLER: 'H',
};
